import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAdformCredentialData, getAdformListAdvertisersData, getAdformListCampaignsData, postAdformRefreshAdvertisers, postAdformSaveCredential, postPublish, postRefreshDcmCampaigns } from "../../../helpers/backend_helper";
import { setAdformAdvertisers, setAdformCampaigns, setAdformCredentialAsked, setAdformCredentialCreated, setAdformCredentialError, setSelectedCreativesPublish } from "../reducer";
import { toggleAdformCredentialModal } from "../../modals/reducer";
import { toast } from "react-toastify";
import { updateCreativePublishStatusAfterPublish } from "../thunk";

export const getAdformCredential = () => async (dispatch, getState) => {
  try {
    const { clientPath } = getState().MenuData;
    const res = await getAdformCredentialData({ clientId: clientPath });
    if (res.status === 'ok') {
      dispatch(setAdformCredentialCreated(true));
    } else {
      dispatch(toggleAdformCredentialModal());
    }
    dispatch(setAdformCredentialAsked(true));
  } catch (error) {
    // console.log(error);
  }
};

export const saveAdformCredential = (body) => async (dispatch, getState) => {
  const {language} = getState().MenuData;
  try {
    const { clientPath } = getState().MenuData;
    const res = await postAdformSaveCredential({ clientId: clientPath, ...body });
    if (res.status === 'ok') {
      dispatch(setAdformCredentialAsked(true));
      dispatch(setAdformCredentialCreated(true));
      return true;
    } else {
      throw res;
    }
  } catch (error) {
    dispatch(setAdformCredentialError(language[error?.code]));
    return false;
  }
};

export const getAdformAdvertisers = () => async (dispatch, getState) => {
  const {language} = getState().MenuData;
  try {
    const { clientPath } = getState().MenuData;
    const res = await getAdformListAdvertisersData({ clientId: clientPath });
    if (res.status === 'ok') {
      dispatch(setAdformAdvertisers(res.data.advertisers));
    } else {
      throw res;
    }
    return true;
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    return false;
  }
};

export const refreshAdformAdvertisers = () => async (dispatch, getState) => {
  const {language} = getState().MenuData;
  try {
    const { clientPath } = getState().MenuData;
    const res = await postAdformRefreshAdvertisers({ clientId: clientPath });
    if (res.status === 'ok') {
      dispatch(setAdformAdvertisers(res.data.advertisers));
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
  }
};


export const getAdformCampaigns = () => async (dispatch, getState) => {
  const {language} = getState().MenuData;
  try {
    const { clientPath } = getState().MenuData;
    const { adformAdvertiserId } = getState().Publish;
    const res = await getAdformListCampaignsData({ clientId: clientPath, advertiserId: adformAdvertiserId });
    if (res.status === 'ok') {
      dispatch(setAdformCampaigns(res.data.campaigns));
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 })
  }
}

export const refreshAdformCampaings = () => async (dispatch, getState) => {
  const {language} = getState().MenuData;
  try {
    const { clientPath } = getState().MenuData;
    const { adformAdvertiserId } = getState().Publish;
    const res = await postRefreshDcmCampaigns({ clientId: clientPath, advertiserId: adformAdvertiserId });
    if (res.status === 'ok') {
      dispatch(setAdformCampaigns(res.data.campaigns));
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 })
  }
}

export const publishAdform = () => async (dispatch, getState) => {
  const {language} = getState().MenuData;
  try {
    const { currentCampaign } = getState().Campaign;
    const { selectedCreativesPublish, adformAdvertiserId, adformCampaignId, adformPoliteLoad, selectedPublishTagId } = getState().Publish;
    let templateType = selectedCreativesPublish[0].hasOwnProperty('figma') ? 'figma' : '';
    const creativeIds = selectedCreativesPublish.map(item => item._id); 
    const res = await postPublish({
      creativeIds: creativeIds,
      campaignId: currentCampaign._id,
      publishType: 'adform',
      adformAdvertiserId: adformAdvertiserId,
      adformCampaignId: adformCampaignId,
      politeLoad: adformPoliteLoad,
      publishTagId: selectedPublishTagId,
      templateType: templateType
    });
    dispatch(setSelectedCreativesPublish([]));
    if (res.status === 'ok') {
      if (res.data.length > 0) {
        dispatch(updateCreativePublishStatusAfterPublish(creativeIds));
        toast.success(language[res.code], { autoClose: 3000 });
      } else {
        toast.error('Something went wrong', {autoClose: 3000});
      }
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}